import saveAs from "file-saver";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import each from "lodash/each";
import get from "lodash/get";

import axios from "@/plugins/axios";

export async function getAll({ commit, state }, params) {
  const force = get(params, "force", false);
  const query = get(params, "query", {});

  if (force || !state.fetched || isEmpty(state.all)) {
    commit("setLoading", 1, { root: true });
    try {
      const response = await axios.get(`${state.endpoint}/get`, {
        params: query,
      });
      const data = get(response, "data.data", []);
      const pagination = get(response, "data.pagination", []);
      commit("setLoading", -1, { root: true });
      commit("setAll", data);
      commit("setPagination", pagination);

      return data;
    } catch (e) {
      commit("setLoading", -1, { root: true });
      return Promise.reject(e);
    }
  }
}

export async function getBy({ commit, state }, params) {
  const id = get(params, "id", 0);
  const context = get(params, "context", 0);
  const dash = get(params, "dash", 0);

  if ((id === 0 || id === null) && context === 0) {
    commit("setOne", {});
    return true;
  }

  if (get(state.one, "id") === id && context === 0) {
    return true;
  }

  if (dash === "dash") {
    const item = state.all.find((item) => item.id === id);
    if (item) {
      commit("setOne", item);
      return true;
    }
  }

  commit("setOne", {});
  commit("setLoading", 1, { root: true });
  try {
    const response = await axios.get(`${state.endpoint}/getby`, {
      params: { id },
    });
    const data = get(response, "data.data", {});
    commit("setOne", data);
    commit("setLoading", -1, { root: true });

    return isEmpty(data) ? Promise.reject(new Error()) : data;
  } catch (e) {
    commit("setLoading", -1, { root: true });
    return Promise.reject(e);
  }
}

export async function getByGlobal({ commit, state }, params) {
  const id = get(params, "id", 0);
  commit("setLoading", 1, { root: true });
  try {
    const response = await axios.get(`${state.endpoint}/getby`, {
      params: { id },
    });
    const data = get(response, "data.data", {});
    commit("setOne", data);
    commit("setLoading", -1, { root: true });

    return isEmpty(data) ? Promise.reject(new Error()) : data;
  } catch (e) {
    commit("setLoading", -1, { root: true });
    return Promise.reject(e);
  }
}

export async function create({ commit, state }) {
  commit("setLoading", 1, { root: true });
  try {
    const response = await axios.post(`${state.endpoint}/add`, state.one);
    const message = get(response, "data.message", {});
    const data = get(response, "data.data", {});

    commit("setCreate", data);
    commit("setLoading", -1, { root: true });
    data.message = message;
    return data;
  } catch (e) {
    commit("setLoading", -1, { root: true });
    return Promise.reject(e);
  }
}

export async function update({ commit, state }) {
  commit("setLoading", 1, { root: true });
  try {
    const response = await axios.put(`${state.endpoint}/upd`, state.one);
    const message = get(response, "data.message", {});
    const data = get(response, "data.data", {});
    commit("setUpdate", data);
    commit("setLoading", -1, { root: true });

    data.message = message;
    return data;
  } catch (e) {
    commit("setLoading", -1, { root: true });
    return Promise.reject(e);
  }
}

export async function updateAll({ commit, state }, payload) {
  commit("setLoading", 1, { root: true });

  try {
    Object.keys(payload).forEach((key) => {
      if (payload[key] == null) delete payload[key];
    });

    const response = await axios.post(`${state.endpoint}/updateall`, null, {
      params: payload,
    });

    const data = get(response, "data.data", {});
    commit("setUpdate", data);
  } catch (e) {
    console.error("Error en update:", e);
    return Promise.reject(e);
  } finally {
    commit("setLoading", -1, { root: true });
  }
}

export async function updatePerfil({ commit, state }) {
  commit("setLoading", 1, { root: true });
  try {
    const response = await axios.put(`${state.endpoint}/updperfil`, state.one);
    const data = get(response, "data.data", {});
    commit("setUpdate", data);
    commit("setLoading", -1, { root: true });

    return data;
  } catch (e) {
    commit("setLoading", -1, { root: true });
    return Promise.reject(e);
  }
}

export async function destroy({ commit, state }, params) {
  const id = get(params, "id", 0);
  const method = isArray(id) ? "post" : "delete";
  const action = isArray(id) ? "delall" : "del";
  const parameters = isArray(id) ? id.map((id) => ({ id })) : { params };

  commit("setLoading", 1, { root: true });
  try {
    const response = await axios[method](
      `${state.endpoint}/${action}`,
      parameters
    );
    const data = get(response, "data.data", {});
    commit("setDestroy", id);
    commit("setLoading", -1, { root: true });

    return data;
  } catch (e) {
    commit("setLoading", -1, { root: true });
    return Promise.reject(e);
  }
}

export function save({ dispatch, state }) {
  if (state.one.id > 0) {
    return dispatch("update");
  } else {
    return dispatch("create");
  }
}

export function savePerfil({ dispatch, state }) {
  if (state.one.id > 0) {
    return dispatch("updatePerfil");
  } else {
    return dispatch("create");
  }
}

export async function upload({ commit }, { endpoint, dataToSend }) {
  if (!dataToSend.file) {
    return Promise.resolve();
  }

  const formData = new FormData();
  each(dataToSend, (value, key) => formData.append(key.toUpperCase(), value));

  commit("setLoading", 1, { root: true });
  try {
    const response = await axios.post(endpoint, formData, {
      baseURL: process.env.VUE_APP_API_URL,
      headers: { "Content-Type": "multipart/form-data" },
    });
    const data = get(response, "data", {});
    commit("setLoading", -1, { root: true });
    return data;
  } catch (e) {
    commit("setLoading", -1, { root: true });
    return Promise.reject(e);
  }
}

export async function download({ commit }, { endpoint, dataToSend, name }) {
  const formData = new FormData();
  each(dataToSend, (value, key) => formData.append(key.toUpperCase(), value));

  commit("setLoading", 1, { root: true });
  try {
    const response = await axios.post(endpoint, formData, {
      baseURL: process.env.VUE_APP_API_URL,
      responseType: "blob",
      headers: { "Content-Type": "multipart/form-data" },
    });
    const data = get(response, "data", []);

    commit("setLoading", -1, { root: true });
    saveAs(new Blob([data]), name);

    return data;
  } catch (e) {
    commit("setLoading", -1, { root: true });
    return Promise.reject(e);
  }
}

export async function custom({ commit }, { method, endpoint, dataToSend }) {
  commit("setLoading", 1, { root: true });
  try {
    const response = await axios[method](endpoint, dataToSend);
    const data = get(response, "data.data", {});
    const message = get(response, "data.message", {});
    commit("setLoading", -1, { root: true });
    data.message = message;

    return data;
  } catch (e) {
    commit("setLoading", -1, { root: true });
    return Promise.reject(e);
  }
}

export async function customGroup(
  { commit },
  { method, endpoint, dataToSend }
) {
  commit("setLoading", 1, { root: true });
  try {
    const response = await axios[method](endpoint, dataToSend);
    const data = get(response, "data", {});
    const message = get(response, "data.message", {});
    commit("setLoading", -1, { root: true });
    data.message = message;

    return data;
  } catch (e) {
    commit("setLoading", -1, { root: true });
    return Promise.reject(e);
  }
}

export async function customR({ commit }, { method, endpoint, dataToSend }) {
  // commit('setLoading', 1, { root: true })
  try {
    const response = await axios[method](endpoint, dataToSend);
    const data = get(response, "data", {});
    const message = get(response, "data.message", {});
    // commit('setLoading', -1, { root: true })
    data.message = message;
    return data;
  } catch (e) {
    commit("setLoading", -1, { root: true });
    return Promise.reject(e);
  }
}

export async function getAllWL({ commit, state }, params) {
  const force = get(params, "force", false);
  const query = get(params, "query", {});

  if (force || !state.fetched || isEmpty(state.all)) {
    try {
      const response = await axios.get(`${state.endpoint}/get`, {
        params: query,
      });
      const data = get(response, "data.data", []);
      const pagination = get(response, "data.pagination", []);
      commit("setAll", data);
      commit("setPagination", pagination);

      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  }
}

export async function updateWL({ commit, state }) {
  try {
    const response = await axios.put(`${state.endpoint}/upd`, state.one);
    const data = get(response, "data.data", {});
    commit("setUpdate", data);

    return data;
  } catch (e) {
    return Promise.reject(e);
  }
}
